import merge from 'deepmerge';

export const validateForm = (values, requiredFields) => {
  let errors = {};
  requiredFields.forEach(field => {
    const keys = field.split('.');
    const value = keys.reduce((prevKey, currentKey) => prevKey && prevKey[currentKey], values);
    if (!value) {
      const error = keys.reduceRight((prevVal, currentKey) => {
        return prevVal ?
          {[currentKey]: prevVal} : {[currentKey]: 'Required'}

      }, null);
       errors = merge(errors, error);
    }
  });
  return errors;
};

